import React from 'react'
import { Toolbar } from '@mui/material'

const SpacerToolbar = (): React.ReactElement => {
    return (
        <>
            {/* Empty Toolbars for spacing: https://material-ui.com/components/app-bar/#fixed-placement */}
            <Toolbar />
        </>
    )
}

export default SpacerToolbar
